<template>
<div class="checkout">
  <MainPreloader
      v-if="loading"
      position="fixed"
      :size="80"
      :stroke="3"
  />
    <StepView :active-index="1" :steps="steps"></StepView>
    <div class="checkout__sections">
      <section class="checkout__left">
        <CheckoutContactData></CheckoutContactData>
        <div class="checkout__header" v-show="showMap">Способ доставки</div>
          <CdekMap
            v-show="showMap"
            @choosePoint="(pointType, pointObject) => (selectedPoint = pointObject) "
          ></CdekMap>
      </section>
      <section class="checkout__right">
         <CheckoutPanel :selected-point="selectedPoint" @update:show-map="showMap = $event"></CheckoutPanel>
      </section>
    </div>

</div>
</template>
<script>
import StepView from "@/components/CartView/StepView.vue";
import {useCartTools} from "@/composables/cart-tools";
import CheckoutContactData from "@/components/CheckoutView/CheckoutContactData.vue";
import {useCartStore} from "@/store/cart";
import {computed, onMounted, reactive, ref} from "vue";
import CheckoutPanel from "@/components/CheckoutView/CheckoutPanel.vue";
import CdekMap from "@/components/CheckoutView/CdekMap.vue";
import {useRouter} from "vue-router";
import MainPreloader from "@/components/shared/MainPreloader.vue";
import {useOrdersStore} from "@/store/orders";

export default {
  name: "CheckoutView",
  components: {MainPreloader, CdekMap, CheckoutPanel, CheckoutContactData, StepView},

  setup() {
    const cartTools = useCartTools();
    const cartStore = useCartStore();
    const orderStore = useOrdersStore();
    const deliveryPoints = reactive([
      {id: 1,  lat: 55.751999, lng: 37.617734}
    ])
    const selectedPoint = ref(null)
    const showMap = ref(false)
    const router = useRouter()
    const loading = computed(() => {
      return cartStore.loading || orderStore.loading;
    })
    onMounted(async () => {
      if (sessionStorage.getItem('left_to_external')) {
        console.log('Вы вернулись с внешнего сайта!');
        sessionStorage.removeItem('left_to_external'); // Очищаем метку
        window.location.reload();
      }

      console.log("MOUNTED!!!!!!!!!!!!!!!!!!!!!")
      await cartStore.loadCart();
      if (cartStore.selectedIds.length === 0) {
        await router.push({name: "CheckoutFinishErrorView"});
      }
    });

    return {
      steps: cartTools.cartSteps,
      deliveryPoints,
      selectedPoint,
      showMap,
      loading
    }
  }
}
</script>



<style scoped lang="scss">
.checkout {
  &__sections {
    display: flex;
    gap: 60px;
    align-items: flex-start;

    @include respond-to('lg') { flex-direction: column; gap: 32px; }
  }

  &__left {
    width: 765px;
    max-width: 100%;

    @include respond-to('lg') { width: 100%; }
  }

  &__right {
    width: 537px;
    max-width: 100%;

    @include respond-to('lg') { width: 100%; }
  }

  &__header {
    padding: 30px 0;
    text-align: left;
    font-family: var(--cd-default-font);
    font-weight: 400;
    font-size: clamp(20px, 3vw, 26px);
  }
}
</style>
